var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.013 2.01 1.028 2.07c.139.286.51.558.824.617l1.86.308c1.188.198 1.465 1.064.612 1.93l-1.45 1.462c-.242.242-.38.719-.3 1.064l.416 1.806c.328 1.424-.43 1.982-1.677 1.233l-1.743-1.042c-.314-.191-.839-.191-1.152 0L4.688 12.5c-1.247.742-2.006.191-1.677-1.233l.415-1.806c.066-.352-.073-.83-.313-1.072L1.66 6.93c-.853-.86-.576-1.726.613-1.931l1.86-.309c.313-.051.685-.33.824-.616l1.028-2.07C6.547.886 7.45.886 8.013 2.01z",
    fill: "#FFB200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e0252d51c9a184e56394422d08b9469e.svg";
export { ForwardRef as ReactComponent };